<template>
    <v-card>
        <loading-component :value="loading"/>
        <v-card-title primary-title class="title" style="background-color: #49BD98">
            <v-flex xs12 class="text-xs-center" style="color: white">
                New Captain
            </v-flex>
        </v-card-title>
        <v-card-text>
            <v-form ref="form">
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">Phone number</v-flex>
                    <v-flex xs6>
                        <v-text-field v-model="captain.username" :rules="[required]" label="Phone"/>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">First Name</v-flex>
                    <v-flex>
                        <v-text-field v-model="captain.first_name" :rules="[required]"
                                      label="First Name"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">Last Name</v-flex>
                    <v-flex>
                        <v-text-field v-model="captain.last_name" :rules="[required]" label="Last Name"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">Gender</v-flex>
                    <v-flex>
                        <ChooseGender v-model="captain.gender"/>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">Car Plate</v-flex>
                    <v-flex>
                        <v-text-field v-model="car.number" :rules="[required]" label="Car Plate"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">Car State</v-flex>
                    <v-flex>
                        <v-select :items="api.CONSTANTS.STATES" v-model="car.state" :rules="[required]"
                                  label="Car state"/>
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-btn color="primary" @click="save">
                        Create Captain
                    </v-btn>
                </v-layout>
            </v-form>
        </v-card-text>
        <v-divider/>
    </v-card>
</template>

<script>
    import ChooseGender from "@/components/monaco/input/ChooseGender";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        components: {LoadingComponent, ChooseGender},
        data() {
            return {
                loading: false,
                captain: {
                    username: null,
                    first_name: null,
                    last_name: null,
                    gender: 1
                },
                car: {
                    number: null,
                    state: null
                }
            }
        },
        methods: {
            save() {
                if (!this.$refs.form.validate())
                    return;

                this.loading = true;
                const {captain, car} = this.$data;
                this.axios.post(this.api.ACTIONS.CAPTAINS, {
                    captain,
                    car
                }).then(({data: {data}}) => {
                    this.$emit("created", data);
                }).catch(({response: {data}}) => window.getApp.$emit("SHOW_TOAST", data.message, "red"))
                    .finally(() => this.loading = false)
            }
        },
        computed: {
            required() {
                return val => !!val || 'Required Field';
            }
        },
        name: "new-captain"
    }
</script>

<style scoped>

</style>